import { Flex, Image, Text } from '@chakra-ui/react'
import { formatPrice } from '../../../../../../utils/formatPrice'
import { Trow } from '../Trow'
import { useMarkup } from '../../../contexts/MarkupProvider'

const imgLoading = '../../../../images/loading-blue.gif'

export function Balanco({ item }) {
  const { loading } = useMarkup()

  const summaryCustoTotal = item.produtos?.reduce(
    (acc, item) => {
      const { lucro_bruto, valor_total_preco_base } = item

      const lucroBruto = parseFloat(lucro_bruto) || 0
      const valorTotalPrecoBase = parseFloat(valor_total_preco_base) || 0

      //valorTotalPrecoBase menos lucroBruto
      const valorTotalPrecoBaseMenosLucroBruto =
        valorTotalPrecoBase - lucroBruto

      return {
        valorTotalPrecoBaseMenosLucroBruto:
          acc.valorTotalPrecoBaseMenosLucroBruto +
          valorTotalPrecoBaseMenosLucroBruto,
      }
    },
    {
      valorTotalPrecoBaseMenosLucroBruto: 0,
    }
  )

  const precoBaseTotal = item.produtos?.reduce((acc, curr) => {
    const { preco_base, quantidade_negociada } = curr

    const precoBase = parseFloat(preco_base) || 0
    const quantidadeNegociada = parseFloat(quantidade_negociada) || 0

    return acc + precoBase * quantidadeNegociada
  }, 0)

  const porcentagem = (parseFloat(item.balanco_lucro) / precoBaseTotal) * 100

  return (
    <>
      <Flex gap={'.1rem'}>
        <Trow
          value={
            <Flex alignItems="center" gap={'.7rem'}>
              <Text as="span" fontWeight="bold">
                BALANÇO DO PEDIDO
              </Text>
            </Flex>
          }
          width={'31.5rem'}
          isPrice
          isBalance
        />
      </Flex>

      <Flex gap={'.1rem'} w="100%" justifyContent="space-between" maxW="500px">
        <Flex flexDir="column" gap={1} w="100%" marginRight=".8rem">
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Juros de pagamento atrasado
            </Text>
            <Text color="#1A8AB6">
              {isNaN(item?.juros_pagamento_atrasado) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(item?.juros_pagamento_atrasado)
              )}
            </Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Lucro sobre condição de pagamento
            </Text>
            <Text color="#1A8AB6">
              {isNaN(item.lucro_condicao_pagamento) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(item.lucro_condicao_pagamento)
              )}
            </Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Lucro sobre frete
            </Text>
            <Text color="#1A8AB6">
              {isNaN(item.lucro_sobre_frete) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(item.lucro_sobre_frete)
              )}
            </Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Sobra innovation
            </Text>
            <Text color="#1A8AB6">
              {isNaN(item.sobra_innovation) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(item.sobra_innovation)
              )}
            </Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              ICMS ST
            </Text>
            <Text color="#1A8AB6">
              {isNaN(item?.icms_st) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(item?.icms_st)
              )}
            </Text>
          </Flex>

          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Custo total
            </Text>
            <Text color="#1A8AB6">
              {isNaN(summaryCustoTotal.valorTotalPrecoBaseMenosLucroBruto) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(
                  summaryCustoTotal.valorTotalPrecoBaseMenosLucroBruto
                )
              )}
            </Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Valor total base
            </Text>
            <Text color="#1A8AB6">{formatPrice(precoBaseTotal)}</Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Frete (Destacado nota)
            </Text>
            <Text color="#1A8AB6">{formatPrice(item.destacado_nota)}</Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Lucro bruto
            </Text>
            <Text color="#1A8AB6">
              {isNaN(item.balanco_lucro) ? (
                <Image src={imgLoading} width="20px" />
              ) : loading ? (
                <Image src={imgLoading} width="20px" />
              ) : (
                formatPrice(item.balanco_lucro)
              )}
            </Text>
          </Flex>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            borderBottom="1px solid #ebebeb"
          >
            <Text fontFamily={'heading'} letterSpacing={'wide'}>
              Porcentagem
            </Text>
            <Text color="#1A8AB6">
              {parseFloat(porcentagem).toFixed(2) + '%'}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
